<template>
    <a
        :href="url"
        target="_blank"
        class="link_button"
    >
        <span v-if="linkTo == 'tool'">入力補助ツール・補足資料</span>
        <span v-else>補足資料</span>
    </a>

</template>

<script>
/**
 * ヘルプボタン
 * [プロパティ]
 * url ... リンク先url
 * linkTo ... リンク先のタイプ。'tool'は「入力補助ツール・補足資料」、それ以外は「補足資料」がリンクボタンの表示名になります。
 * 
 * [イベント処理]
 * クリック時 ... this.$emit('click', name)
 * 
 * [利用例]
 * <link-button
 *     :link="https://~"
 *     :link-to="tool"
 * />
 */
export default {
    name:"LinkButton",
    props: {
        /**
         * リンク先のurl
         */
        url: {
            type: String,
            required: true
        },
        /**
         * リンク先のタイプ（現状は[tool]、それ以外の2種類です）
         */
        linkTo: {
            type: String,
        },
    },
}
</script>

<style scoped>
.link_button{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: auto;
    height: 1.5em;
    margin-top: 4px;
    padding: 2px 8px;
    font-size: 12px;
    line-height: 12px;
    font-weight: bolder;
    text-align: center;
    color: #1C4373;
    background-color: #efefef;
    border-radius: 8px;
    box-shadow: none;
    cursor:pointer;
}
.link_button:after{
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(/img/all_icons.png) no-repeat; /* スプライト呼び出し */
    background-size: auto calc( 225 / 72 * 100% );
    background-position-x: calc(142 / (1725 - 1015) * 100%);
    background-position-y: calc(120 / (225 - 72) * 100%);
}
.link_button:hover{
    color: white;
    background-color: #1C4373;
}
.grid_2 .link_button{
    height: 1.2em;
    margin-top: 0;
}
_:-ms-lang(x)::-ms-backdrop, div.help_button {
    padding: 4px 0 0;
}

_:-ms-lang(x)::-ms-backdrop, div.rotate {
    padding: 0 4px 0 0;
}
</style>